import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';

export const PaginationControls = ({
  page,
  totalPages,
  isFetching,
  pagingForward,
  onPrev,
  onNext,
}: {
  page: number;
  totalPages: number;
  isFetching: boolean;
  pagingForward: boolean;
  onPrev: () => void;
  onNext: () => void;
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.info}><Text style={styles.infoText}>Page {page + 1} of {totalPages}</Text></View>
      <View style={styles.controls}>
        <TouchableOpacity
          style={[styles.button, page === 0 && styles.buttonDisabled]}
          onPress={onPrev}
          disabled={page === 0 || isFetching}
          accessibilityLabel="Previous page"
          accessibilityRole="button"
        >
          <Text style={styles.buttonText}>Previous</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.button, page >= totalPages - 1 && styles.buttonDisabled, isFetching && pagingForward && styles.buttonLoading]}
          onPress={onNext}
          disabled={page >= totalPages - 1 || isFetching}
          accessibilityLabel="Next page"
          accessibilityRole="button"
        >
          <Text style={styles.buttonText}>Next</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: ADMIN_COLORS.BORDER + '40',
  },
  info: { alignItems: 'center', marginBottom: 12 },
  infoText: { fontSize: 14, fontWeight: '500', color: ADMIN_COLORS.TEXT_SECONDARY },
  controls: { flexDirection: 'row', justifyContent: 'center', gap: 12 },
  button: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
    backgroundColor: ADMIN_COLORS.PRIMARY,
    minWidth: 100,
    alignItems: 'center',
  },
  buttonLoading: { opacity: 0.9 },
  buttonDisabled: { backgroundColor: ADMIN_COLORS.DATA_TABLE.BACKGROUND },
  buttonText: { fontSize: 14, fontWeight: '600', color: 'white' },
});


